import { create } from "zustand";

export type ThemePreference = "light" | "dark" | "system";

interface UiState {
  quickAddOpen: boolean;
  commandOpen: boolean;
  sidebarCollapsed: boolean;
  dirtySources: Record<string, boolean>;
  setQuickAddOpen: (open: boolean) => void;
  setCommandOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  setDraftSource: (source: string, dirty: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  quickAddOpen: false,
  commandOpen: false,
  sidebarCollapsed: false,
  dirtySources: {},
  setQuickAddOpen: (quickAddOpen) => set({ quickAddOpen }),
  setCommandOpen: (commandOpen) => set({ commandOpen }),
  toggleSidebar: () =>
    set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setDraftSource: (source, dirty) => set((state) => ({ dirtySources: { ...state.dirtySources, [source]: dirty } }))
}));
